// Generated from the product translation catalog; keep keys aligned across locales.
export const tr = {
  'layout.account': 'Hesabım',
  'layout.accountPreferences': 'Hesap ve tercihler',
  'layout.myProfile': 'Profilim',
  'layout.signOut': 'Çıkış yap',
  'layout.language': 'Dil',
  'layout.appearance': 'Tema',
  'layout.menu': 'Menü',
  'layout.openMenu': 'Ana menüyü aç',
  'layout.back': 'Geri',
  'layout.closeMenu': 'Menüyü kapat',
  'layout.pageActions': 'Sayfa işlemleri',
  'layout.mainNavigation': 'Ana menü',
  'layout.supportNavigation': 'Yardım menüsü',
  'layout.dailyWork': 'GÜNLÜK İŞLER',
  'layout.administration': 'YÖNETİM',
  'layout.reporting': 'RAPORLAMA',
  'layout.yourBusiness': 'İŞLETMENİZ',
  'layout.businessAccount': 'İşletme hesabı',
  'layout.allCompanies': 'Tüm şirketler',
  'layout.workspace': 'Çalışma alanı',
  'layout.tagline': 'İşinizin kaydı, elinizin altında.',
  'layout.faq': 'Sıkça Sorulan Sorular',
  'layout.skipContent': 'İçeriğe geç',
  // Navigation
  'nav.dashboard': 'Ana Sayfa',
  'nav.reports': 'Raporlar',
  'nav.companies': 'Şirketler',
  'nav.users': 'Kullanıcılar',
  'nav.customers': 'Müşteriler',
  'nav.items': 'Ürünler',
  'nav.sales': 'Satışlar',
  'nav.sale-history': 'Satış Geçmişi',
  'nav.debts': 'Cari Hesaplar',
  'nav.expenses': 'Gider Defteri',
  'nav.profile': 'Profil',
  'nav.help': 'Yardım',
  'nav.faq': 'SSS',
  'nav.logout': 'Çıkış',
  
  // Auth
  'auth.login': 'Giriş',
  'auth.accessDeniedTitle': 'Bu sayfaya erişilemiyor',
  'auth.accessDeniedDescription': 'Hesabınızın bu sayfayı görüntüleme yetkisi yok.',
  'auth.accessDeniedHelp': 'Doğru hesapla giriş yaptığınızı kontrol edin veya yardım sayfasını açın.',
  'auth.signInDescription': 'İşletmenizin hesaplarına güvenle erişin.',
  'auth.showPassword': 'Şifreyi göster',
  'auth.hidePassword': 'Şifreyi gizle',
  'auth.registrationDescription': 'Birkaç adımda işletmeniz için hesabınızı oluşturun.',
  'auth.registrationNextStep': 'Kaydı tamamladıktan sonra e-postanıza gelen kodla hesabınızı doğrulayın.',
  'auth.registrationEmailHint': 'Hesap doğrulaması için gereklidir.',
  'auth.phoneNumberMinLength': 'Telefon numarası en az 10 karakter olmalıdır.',
  'auth.email': 'E-posta',
  'auth.password': 'Şifre',
  'auth.loginButton': 'Giriş Yap',
  'auth.forgotPassword': 'Şifremi unuttum',
  'auth.forgotPasswordDescription': 'E-posta adresinizi girin; size şifre sıfırlama bağlantısı gönderelim.',
  'auth.sendPasswordResetLink': 'Sıfırlama bağlantısı gönder',
  'auth.passwordResetRequestAccepted': 'Bu e-posta ile kayıtlı bir hesap varsa şifre sıfırlama bağlantısı gönderildi.',
  'auth.passwordResetRequestFailed': 'Şifre sıfırlama isteği oluşturulamadı. Lütfen tekrar deneyin.',
  'auth.resetPassword': 'Şifreyi sıfırla',
  'auth.resetPasswordDescription': 'Hesabınız için yeni bir şifre belirleyin.',
  'auth.newPassword': 'Yeni şifre',
  'auth.resetPasswordButton': 'Yeni şifreyi kaydet',
  'auth.invalidPasswordResetLink': 'Şifre sıfırlama bağlantısı geçersiz veya eksik.',
  'auth.passwordResetSuccess': 'Şifreniz sıfırlandı. Artık giriş yapabilirsiniz.',
  'auth.passwordResetFailed': 'Şifre sıfırlama başarısız. Bağlantı geçersiz veya süresi dolmuş olabilir.',
  'auth.register': 'Kayıt Ol',
  'auth.firstName': 'Ad',
  'auth.lastName': 'Soyad',
  'auth.username': 'Kullanıcı Adı',
  'auth.phoneNumber': 'Telefon Numarası',
  'auth.registerButton': 'Kayıt Ol',
  'auth.alreadyHaveAccount': 'Zaten hesabınız var mı?',
  'auth.dontHaveAccount': 'Hesabınız yok mu?',
  'auth.createAccount': 'Hesap Oluştur',
  'auth.personalInfo': 'Kişisel Bilgiler',
  'auth.accountDetails': 'Hesap Detayları',
  'auth.companyInfo': 'Şirket Bilgileri',
  'auth.referralCode': 'Referans kodu',
  'auth.referralCodeHint': 'Sizi davet eden kişinin kodunu girebilirsiniz.',
  'auth.verification': 'Doğrulama',
  'auth.next': 'İleri',
  'auth.back': 'Geri',
  'auth.finish': 'Tamamla',
  'auth.step': 'Adım',
  'auth.of': '/',
  'auth.orContinueWith': 'Veya şununla devam et',
  'auth.continueWithGoogle': 'Google ile Devam Et',
  'auth.continueWithFacebook': 'Facebook ile Devam Et',
  'auth.comingSoon': 'Yakında Gelecek',
  'auth.googleLoginComingSoon': 'Google ile giriş yakında eklenecek',
  'auth.facebookLoginComingSoon': 'Facebook ile giriş yakında eklenecek',
  'auth.emailVerification': 'E-posta Doğrulama',
  'auth.verifyEmail': 'E-postayı Doğrula',
  'auth.verificationSent': 'Doğrulama e-postası gönderildi!',
  'auth.checkEmail': 'Lütfen doğrulama bağlantısı için e-postanızı kontrol edin',
  'auth.resendVerification': 'Doğrulama E-postasını Tekrar Gönder',
  'auth.emailVerified': 'E-posta Doğrulandı!',
  'auth.emailVerifiedMessage': 'E-postanız başarıyla doğrulandı. Artık giriş yapabilirsiniz.',
  'auth.verificationFailed': 'Doğrulama Başarısız',
  'auth.invalidToken': 'Geçersiz veya süresi dolmuş doğrulama kodu',
  'auth.emailNotVerified': 'Giriş yapmadan önce lütfen e-postanızı doğrulayın. Gelen kutunuzdaki doğrulama bağlantısını kontrol edin.',
  'auth.invalidCredentials': 'Geçersiz kullanıcı adı/e-posta veya şifre. Lütfen tekrar deneyin.',
  'auth.userNotFound': 'Kullanıcı bulunamadı. Lütfen kullanıcı adınızı veya e-posta adresinizi kontrol edin.',
  'auth.serverConnectionError': 'Sunucuya bağlanılamıyor. Lütfen backend servisinin çalıştığından emin olun.',
  'auth.loginFailed': 'Giriş başarısız. Lütfen tekrar deneyin.',
  'auth.fieldRequired': 'Bu alan zorunludur',
  'auth.usernameOrEmailHelper': 'Kullanıcı adınızı veya e-posta adresinizi girin',
  'auth.confirmPassword': 'Şifre Tekrarı',
  'auth.passwordMismatch': 'Şifreler eşleşmiyor',
  'auth.emailInvalid': 'Lütfen geçerli bir e-posta adresi girin',
  'auth.passwordMinLength': 'Şifre en az 6 karakter olmalıdır',
  'auth.usernameMinLength': 'Kullanıcı adı en az 3 karakter olmalıdır',
  'auth.verifyingEmail': 'E-postanız doğrulanıyor...',
  'auth.redirectingToLogin': 'Giriş sayfasına yönlendiriliyorsunuz...',
  'auth.enterEmailAndCode': 'E-postanızı ve gelen kutunuza gönderilen 6 haneli doğrulama kodunu girin',
  'auth.verificationCodeLength': 'Doğrulama kodu 6 karakter olmalıdır',
  'auth.verificationCodeHelper': 'E-postanızdaki 6 karakterlik kodu girin',
  'auth.verificationCodeLabel': 'Doğrulama Kodu (6 karakter)',
  'auth.verifyEmailButton': 'E-postayı Doğrula',
  'auth.resendVerificationCode': 'Doğrulama Kodunu Tekrar Gönder',
  'auth.backToLogin': 'Giriş Sayfasına Dön',
  'auth.tryAgainWithCode': 'Kod ile Tekrar Dene',
  'auth.goToLogin': 'Giriş Yap',
  'auth.or': 'VEYA',
  'auth.backToHome': 'Ana Sayfaya Dön',
  'auth.verifyYourEmail': 'E-postanızı Doğrulayın',
  'auth.emailAddress': 'E-posta Adresi',
  'auth.registrationFailed': 'Kayıt başarısız oldu. Lütfen tekrar deneyin.',
  'auth.verificationResent': 'Doğrulama e-postası gönderildi! Lütfen gelen kutunuzu kontrol edin.',
  'auth.verificationResendFailed': 'Doğrulama e-postası gönderilemedi',
  'auth.verificationThrottled': 'Yeni bir doğrulama e-postası istemeden önce lütfen bekleyin.',
  'auth.verificationRetryAfter': '{{seconds}} saniye sonra tekrar deneyebilirsiniz.',
  'auth.verificationCodeFailed': 'Doğrulama başarısız. Lütfen kodunuzu kontrol edip tekrar deneyin.',
  'auth.enterEmailAddress': 'Lütfen e-posta adresinizi girin',
  'auth.enterEmailAndCodeError': 'Lütfen e-posta ve doğrulama kodunu girin',
  'auth.emailVerificationSuccessShort': 'E-posta doğrulandı! Artık giriş yapabilirsiniz.',
  'auth.phoneNumberRequired': 'Telefon numarası zorunludur',
  'auth.phoneNumberInvalid': 'Lütfen geçerli bir telefon numarası girin',
  'auth.companyName': 'Şirket Adı',
  'auth.companyAddress': 'Şirket Adresi',
  'auth.companyPhone': 'Şirket Telefonu',
  'auth.companyEmail': 'Şirket E-postası',
  'auth.companyWebsite': 'Şirket Web Sitesi',
  
  // Common
  'common.add': 'Ekle',
  'common.edit': 'Düzenle',
  'common.delete': 'Sil',
  'common.save': 'Kaydet',
  'common.ok': 'Tamam',
  'common.processing': 'İşleniyor...',
  'common.saving': 'Kaydediliyor...',
  'common.columns': 'Sütunlar',
  'common.cancel': 'İptal',
  'common.close': 'Kapat',
  'common.create': 'Oluştur',
  'common.update': 'Güncelle',
  'common.search': 'Ara',
  'common.clearSearch': 'Aramayı temizle',
  'common.filters': 'Filtreler',
  'common.view': 'Görüntüle',
  'common.all': 'Tümü',
  'common.clearFilters': 'Filtreleri Temizle',
  'common.actions': 'İşlemler',
  'common.name': 'Ad',
  'common.email': 'E-posta',
  'common.phone': 'Telefon',
  'common.address': 'Adres',
  'common.price': 'Fiyat',
  'common.loading': 'Yükleniyor...',
  'common.error': 'Hata',
  'common.success': 'Başarılı',
  'common.confirm': 'Onayla',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.page': 'Sayfa',
  'common.of': '/',
  'common.showing': 'Gösterilen',
  'common.rowsPerPage': 'Sayfa başına satır',
  'common.areYouSure': 'Emin misiniz?',
  'common.thisActionCannotBeUndone': 'Bu işlem geri alınamaz.',
  'common.comingSoon': 'Yakında',
  'common.optional': 'Opsiyonel',
  'common.created': 'Oluşturulma',
  'common.createdAt': 'Oluşturulma Tarihi',
  'common.retry': 'Tekrar Dene',
  'common.rateLimit': 'Çok fazla istek gönderildi. Lütfen biraz sonra tekrar deneyin.',
  'common.rateLimitWithRetry': 'Çok fazla istek gönderildi. {seconds} saniye sonra tekrar deneyin.',
  'common.found': 'Bulundu',
  'common.matching': 'eşleşen',
  'common.tryAdjusting': 'Arama terimlerinizi ayarlamayı deneyin',
  'common.getStarted': 'İlk',
  'common.system': 'Sistem',
  'common.noFound': '{0} bulunamadı',
  'common.noYet': 'Henüz {0} yok',
  'common.addFirst': 'İlk {0} Ekle',
  'common.searchBy': '{1} ile {0} ara...',
  'common.management': '{0} Yönetimi',
  'subscription.readOnlyBanner': 'Aboneliğiniz sona erdi veya salt okunur durumda. Yeni kayıt ve değişiklik işlemleri kullanılamıyor.',
  'common.removing': 'Kaldırılıyor...',
  'common.adjusting': 'Ayarlanıyor...',
  'common.adding': 'Ekleniyor...',
  
  // Companies
  'companies.title': 'Şirketler',
  'companies.subtitle': 'İşletme hesaplarını ve aboneliklerini yönetin.',
  'companies.formHint': 'Şirketin temel iletişim bilgilerini ekleyin.',
  'companies.clearSearch': 'Aramayı temizle',
  'companies.nameRequired': 'Şirket adı zorunludur.',
  'companies.emailInvalid': 'Geçerli bir e-posta adresi girin.',
  'companies.phoneInvalid': 'Geçerli bir telefon numarası girin.',
  'companies.websiteInvalid': 'Web adresi http:// veya https:// ile başlamalıdır.',
  'companies.saveError': 'Şirket kaydedilemedi.',
  'companies.loadError': 'Şirketler yüklenemedi.',
  'companies.createSuccess': 'Şirket oluşturuldu.',
  'companies.updateSuccess': 'Şirket güncellendi.',
  'companies.addCompany': 'Şirket Ekle',
  'companies.source': 'Kayıt kaynağı',
  'companies.sourceReferral': 'Referanslı',
  'companies.sourceOrganic': 'Organik',
  'companies.sourceAdmin': 'Yönetim oluşturdu',
  'companies.sourceLegacy': 'Geçmiş / bilinmiyor',
  'subscription.manage': 'Aboneliği yönet',
  'subscription.manageTitle': 'Abonelik yönetimi',
  'subscription.formHint': 'Planın durumunu ve geçerlilik tarihlerini belirleyin.',
  'subscription.paidActivation': 'İlk ücretli aktivasyonu doğrula ve referans ödülünü işlet',
  'subscription.invalidDateRange': 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
  'subscription.planCode': 'Plan kodu',
  'subscription.status': 'Durum',
  'subscription.active': 'Aktif',
  'subscription.readOnly': 'Salt okunur',
  'subscription.suspended': 'Askıya alınmış',
  'subscription.startsAt': 'Başlangıç tarihi',
  'subscription.endsAt': 'Bitiş tarihi',
  'subscription.endsAtHelper': 'Sınırsız abonelik için boş bırakın.',
  'subscription.notes': 'Notlar',
  'subscription.saved': 'Abonelik güncellendi',
  'subscription.loadFailed': 'Abonelik bilgisi yüklenemedi',
  'subscription.saveFailed': 'Abonelik güncellenemedi',
  'companies.editCompany': 'Şirket Düzenle',
  'companies.deleteCompany': 'Şirket Sil',
  'companies.companyName': 'Şirket Adı',
  'companies.website': 'Web Sitesi',
  'companies.priceEntryMode': 'Katalog fiyat girişi',
  'companies.priceEntryModeVatExcluded': 'Fiyatlar KDV hariç',
  'companies.priceEntryModeVatIncluded': 'Fiyatlar KDV dahil',
  'companies.defaultVatRate': 'Varsayılan KDV oranı',
  'companies.defaultVatRateHint': 'Yeni ürünlere uygulanır; ürün bazında değiştirilebilir.',
  'companies.defaultVatRateInvalid': 'Desteklenen KDV oranlarından birini seçin: %0, %1, %10 veya %20.',
  'companies.batchTrackingEnabled': 'Parti takibini etkinleştir',
  'companies.batchTrackingHint': 'Parti numarası ve son kullanma tarihi gibi alanları şirket genelinde kullanın.',
  'companies.deleteConfirm': 'Bu şirketi silmek istediğinizden emin misiniz?',
  'companies.searchByNameEmailPhone': 'İsim, e-posta veya telefon ile şirket ara...',
  'companies.searchPlaceholder': 'Şirket ara...',
  'companies.noFound': 'Şirket bulunamadı',
  'companies.noYet': 'Henüz şirket yok',
  'companies.getStarted': 'İlk şirketinizi ekleyerek başlayın',
  'companies.addFirstCompany': 'İlk Şirket Ekle',
  'companies.createCompany': 'Yeni Şirket Oluştur',
  'companies.saving': 'Kaydediliyor...',
  'companies.create': 'Oluştur',
  'companies.detailLoadError': 'Şirket bilgileri yüklenemedi.',
  'companies.summaryLoadError': 'Şirket özeti yüklenemedi.',
  'companies.subscriptionStatus': 'Fiili abonelik',
  'companies.subscriptionEnds': 'Bitiş / kalan',
  'companies.usageStatus': 'Kullanım durumu',
  'companies.allStatuses': 'Tüm abonelikler',
  'companies.allUsageStatuses': 'Tüm kullanım durumları',
  'companies.expiringFilter': 'Bitiş filtresi',
  'companies.allExpiry': 'Tüm bitiş tarihleri',
  'companies.expiring7': '7 gün içinde bitecek',
  'companies.expiring30': '30 gün içinde bitecek',
  'companies.usageActive': 'Son 30 günde kullandı',
  'companies.usageInactive': '30 gündür kullanmıyor',
  'companies.usageNever': 'Henüz kullanmadı',
  'companies.days': 'gün',
  'companies.unlimited': 'Süresiz',
  'companies.companyOperations': 'Şirket verileri',
  'companies.companyOperationsHint': 'Bu şirketin müşteri ve ürün kayıtlarını kapsam korunarak açın.',
  'companies.openCustomers': 'Müşterileri aç',
  'companies.openItems': 'Ürünleri aç',
  'companies.openSales': 'Satışları aç',
  'companies.openDebts': 'Cari hareketleri aç',
  'companies.openExpenses': 'Giderleri aç',
  'companies.detailOverview': 'Genel bakış',
  'companies.detailUsers': 'Kullanıcılar',
  'companies.detailSubscription': 'Abonelik',
  'companies.detailNotes': 'Notlar',
  'companies.createdAt': 'Kayıt tarihi',
  'companies.usersCount': 'Kullanıcı',
  'companies.customersCount': 'Müşteri',
  'companies.itemsCount': 'Ürün',
  'companies.periodSales': 'Dönem satışı',
  'companies.periodCollections': 'Dönem tahsilatı',
  'companies.lastActivity': 'Son iş aktivitesi',
  'companies.neverUsed': 'Henüz işlem yok',
  'companies.notesFromDetail': 'Şirket içi görüşme ve takip notları.',
  'companies.addNote': 'Not ekle',
  'common.back': 'Geri',
  'companies.update': 'Güncelle',
  'companies.deleting': 'Siliniyor...',
  'companies.deleteWarning': 'Bu işlem geri alınamaz. Bu şirketle ilişkili tüm veriler kalıcı olarak silinecektir.',
  'companies.deleteQuestion': 'Bu şirketi silmek istediğinizden emin misiniz? Bu işlem aşağıdakileri de silecektir:',
  'companies.deleteSuccess': 'Şirket başarıyla silindi',
  'companies.deleteConsequences.allUsers': 'Bu şirketle ilişkili tüm kullanıcılar',
  'companies.deleteConsequences.allCustomers': 'Bu şirketle ilişkili tüm müşteriler',
  'companies.deleteConsequences.allItems': 'Bu şirketle ilişkili tüm ürünler/envanter',
  'companies.deleteConsequences.allData': 'Tüm ilgili veriler ve geçmiş',
  'companies.deleteError.generic': 'Şirket silinemedi',
  'companies.deleteError.hasUsers': 'Şirket silinemiyor: Bu şirketle ilişkili kullanıcılar bulunmaktadır. Lütfen önce tüm kullanıcıları bu şirketten kaldırın.',
  'companies.deleteError.hasData': 'Şirket silinemiyor: Bu şirketle ilişkili veriler bulunmaktadır. Lütfen önce tüm ilişkili verileri kaldırın.',
  
  // Users
  'users.title': 'Kullanıcılar',
  'users.subtitle': 'Ekibinizin hesaplarını ve erişim rollerini yönetin.',
  'users.passwordRequired': 'Şifre zorunludur',
  'users.companyRequired': 'Bu rol için şirket seçin',
  'users.keepPassword': 'Mevcut şifreyi korumak için boş bırakın',
  'users.loadingCompanies': 'Şirketler yükleniyor...',
  'users.createSuccess': 'Kullanıcı oluşturuldu',
  'users.updateSuccess': 'Kullanıcı güncellendi',
  'users.deleteSuccess': 'Kullanıcı silindi',
  'users.saveError': 'Kullanıcı kaydedilemedi',
  'users.deleteError': 'Kullanıcı silinemedi',
  'users.addUser': 'Kullanıcı Ekle',
  'users.editUser': 'Kullanıcı Düzenle',
  'users.deleteUser': 'Kullanıcı Sil',
  'users.username': 'Kullanıcı Adı',
  'users.role': 'Rol',
  'users.company': 'Şirket',
  'users.created': 'Oluşturulma',
  'users.deleteConfirm': 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
  'users.addEmployee': 'Çalışan Ekle',
  'users.management': 'Kullanıcı Yönetimi',
  'users.createUser': 'Yeni Kullanıcı Oluştur',
  'users.firstName': 'Ad',
  'users.lastName': 'Soyad',
  'users.name': 'Ad',
  'users.password': 'Şifre',
  'users.confirmPassword': 'Şifre Onayı',
  'users.selectRole': 'Rol Seç',
  'users.selectCompany': 'Şirket Seç',
  'users.noEmail': 'E-posta yok',
  'users.noUsers': 'Kullanıcı bulunamadı',
  'users.noSearchResults': 'Arama sonucu bulunamadı',
  'users.noUsersYet': 'Henüz kullanıcı yok',
  'users.searchUsers': 'Kullanıcı adı veya isim ile kullanıcı ara...',
  'users.addFirstUser': 'İlk Kullanıcı Ekle',
  'users.addFirstEmployee': 'İlk Çalışan Ekle',
  'users.saving': 'Kaydediliyor...',
  'users.create': 'Oluştur',
  'users.update': 'Güncelle',
  'users.emailVerificationSent': 'Yeni adrese doğrulama e-postası gönderildi',
  'users.deleting': 'Siliniyor...',
  'users.deleteWarning': 'Bu işlem geri alınamaz. Kullanıcı sisteme erişimini hemen kaybedecektir.',
  'users.deleteQuestion': 'Bu kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem:',
  'users.deleteConsequences.removeAccess': 'Kullanıcının sisteme erişimini kaldırır',
  'users.deleteConsequences.preserveData': 'Geçmiş verileri korur (işlemler, vb.)',
  'users.deleteConsequences.cannotUndo': 'Kullanıcıyı yeniden oluşturmadan geri alınamaz',
  'users.deleteConsequences.companyAdminWarning': 'Uyarı: Bu işlem bir Şirket Yöneticisini kaldıracaktır',
  
  // Customers
  'customers.title': 'Müşteriler',
  'customers.directoryEyebrow': 'MÜŞTERİ REHBERİ',
  'customers.directoryDescription': 'İletişim bilgilerini düzenleyin, cari hesaba kolayca ulaşın.',
  'customers.previousPage': 'Önceki sayfa',
  'customers.nextPage': 'Sonraki sayfa',
  'customers.clearSearch': 'Aramayı temizle',
  'customers.addCustomer': 'Müşteri Ekle',
  'customers.editCustomer': 'Müşteri Düzenle',
  'customers.deleteCustomer': 'Müşteri Sil',
  'customers.bulkUpload': 'Toplu Yükleme',
  'customers.importCsv': 'CSV içe aktar',
  'customers.deleteConfirm': 'Bu müşteriyi silmek istediğinizden emin misiniz?',
  'customers.customerName': 'Müşteri Adı',
  'customers.searchByName': 'İsme göre müşteri ara...',
  'customers.searchPlaceholder': 'Müşteri ara...',
  'customers.noCustomers': 'Müşteri bulunamadı',
  'customers.noSearchResults': 'Arama sonucu bulunamadı',
  'customers.tryDifferentSearch': 'Farklı bir arama terimi deneyin',
  'customers.phone': 'Telefon',
  'customers.email': 'E-posta',
  'customers.call': 'Call',
  'customers.write': 'Write',
  'customers.address': 'Adres',
  'customers.taxIdentificationNumber': 'Vergi Kimlik Numarası',
  'customers.taxIdentificationNumberOptional': 'İsteğe bağlı; VKN/TCKN veya ilgili vergi numarasını yazabilirsiniz',
  'customers.name': 'Ad',
  'customers.company': 'Şirket',
  'customers.noFound': 'Müşteri bulunamadı',
  'customers.noYet': 'Henüz müşteri yok',
  'customers.customerInfo': 'Müşteri Bilgileri',
  'customers.notFound': 'Müşteri bulunamadı',
  'customers.loadError': 'Müşteri yüklenemedi',
  'customers.getStarted': 'İlk müşterinizi ekleyerek başlayın',
  'customers.addFirstCustomer': 'İlk Müşteri Ekle',
  'customers.firstName': 'Ad',
  'customers.lastName': 'Soyad',
  'customers.createCustomer': 'Yeni Müşteri Oluştur',
  'customers.saving': 'Kaydediliyor...',
  'customers.create': 'Oluştur',
  'customers.update': 'Güncelle',
  'customers.deleting': 'Siliniyor...',
  'customers.created': 'Müşteri başarıyla oluşturuldu',
  'customers.updated': 'Müşteri başarıyla güncellendi',
  'customers.deleted': 'Müşteri başarıyla silindi',
  'customers.errors.invalidEmail': 'Geçersiz e-posta formatı',
  'customers.errors.invalidPhone': 'Geçersiz telefon formatı',
  'customers.errors.missingField': 'Zorunlu alan eksik',
  'customers.errors.alreadyExists': 'zaten mevcut',
  'customers.errors.emailAlreadyExists': 'Bu e-posta adresine sahip müşteri zaten mevcut',
  'customers.errors.taxIdentificationNumberAlreadyExists': 'Bu vergi kimlik numarasına sahip müşteri zaten mevcut',
  'customers.errors.duplicateNameRequiresIdentifier': 'Bu isimde bir müşteri zaten mevcut. Ayırt edebilmek için telefon, e-posta veya vergi kimlik numarası ekleyin',
  'customers.errors.alreadyExistsInCompany': 'Bu müşteri bu şirkette zaten mevcut',
  'customers.errors.saveFailed': 'Müşteri kaydedilemedi',
  'customers.deleteWarning': 'Bu işlem geri alınamaz. Bu müşteriyle ilişkili tüm veriler kalıcı olarak silinecektir.',
  'customers.deleteQuestion': 'Bu müşteriyi silmek istediğinizden emin misiniz? Bu işlem aşağıdakileri de silecektir:',
  'customers.deleteConsequences.allTransactions': 'Bu müşteriyle yapılan tüm işlemler',
  'customers.deleteConsequences.allInvoices': 'Tüm faturalar ve ödeme geçmişi',
  'customers.deleteConsequences.allData': 'Tüm ilgili müşteri verileri',
  
  // Items
  'items.title': 'Ürünler',
  'items.nameRequired': 'Ürün adı zorunludur.',
  'items.invalidCode': 'Yalnızca harf, rakam, nokta, tire, alt çizgi ve eğik çizgi kullanın.',
  'items.priceRequired': 'Geçerli bir satış fiyatı girin.',
  'items.pricePositive': 'Satış fiyatı sıfırdan büyük olmalıdır.',
  'items.itemType': 'Kayıt türü',
  'items.productType': 'Ürün',
  'items.serviceType': 'Hizmet',
  'items.defaultPriceOptional': 'Varsayılan fiyat (isteğe bağlı)',
  'items.servicePriceHelp': 'Fiyat hizmet satılırken belirlenir.',
  'items.servicePriceAtSale': 'Satışta belirlenir',
  'items.inventoryNotTracked': 'Takip edilmiyor',
  'items.catalogSubtitle': 'Ürünlerinizi, fiyatlarını ve stok durumunu tek yerden yönetin.',
  'items.lowStock': 'Azalan stok',
  'items.stockHealthy': 'Stok yeterli',
  'items.openInventory': 'Stoku görüntüle',
  'items.clearFilters': 'Filtreleri temizle',
  'items.allCategories': 'Tüm kategoriler',
  'items.addItem': 'Ürün Ekle',
  'items.editItem': 'Ürün Düzenle',
  'items.deleteItem': 'Ürün Sil',
  'items.itemName': 'Ürün Adı',
  'items.itemNumber': 'Ürün Kodu',
  'items.itemNumberHelp': 'İsterseniz akılda kalıcı bir kod girin; boş bırakırsanız otomatik atanır',
  'items.barcode': 'Barkod',
  'items.barcodeHelp': 'İsteğe bağlı; barkod okuyucudan gelen değeri aramada kullanabilirsiniz',
  'barcode.scan': 'Okut',
  'barcode.scanTitle': 'Barkod okut',
  'barcode.scannerHint': 'Kamerayı veya USB/Bluetooth barkod okuyucuyu kullanabilir ya da kodu elle girebilirsiniz.',
  'barcode.scannerInput': 'Barkodu okutun veya girin',
  'barcode.useCode': 'Kodu kullan',
  'barcode.startCamera': 'Kamerayı başlat',
  'barcode.stopCamera': 'Kamerayı durdur',
  'barcode.cameraUnavailable': 'Kamera başlatılamadı. Kamera erişimine izin verip sayfayı HTTPS üzerinden açın ya da barkodu elle girin.',
  'barcode.testTitle': 'Barkod okuyucu denemesi',
  'barcode.testDescription': 'Telefonunuzun kamerasıyla bir ürün barkodunu okutmayı deneyin. Kod burada görünür ve kaydedilmez.',
  'barcode.scanResult': 'Okunan barkod',
  'barcode.scanEmpty': 'Henüz barkod okutulmadı.',
  'items.deleteConfirm': 'Bu ürünü silmek istediğinizden emin misiniz?',
  'items.management': 'Ürün Yönetimi',
  'items.addNewItem': 'Yeni Ürün Ekle',
  'items.createItem': 'Yeni Ürün Oluştur',
  'items.manageInventory': 'Envanter ürünlerinizi yönetin',
  'items.searchByName': 'İsme göre ürün ara...',
  'items.searchPlaceholder': 'Ürün ara...',
  'items.name': 'Ad',
  'items.description': 'Açıklama',
  'items.price': 'Fiyat',
  'items.salePrice': 'Satış fiyatı',
  'items.vatRate': 'KDV oranı',
  'items.vatRateHelp': 'Bu KDV oranı ürüne kaydedilir ve gelecekteki satışlarda ve faturalarda kullanılır.',
  'items.vatRateInvalid': 'Desteklenen KDV oranlarından birini seçin: %0, %1, %10 veya %20.',
  'items.vatRatePresets': 'Yaygın KDV oranları',
  'items.priceEntryModeHint': 'Fiyat, şirketinizin katalog fiyat giriş ayarına göre kaydedilir.',
  'items.priceEntryModeVatExcluded': 'KDV hariç',
  'items.priceEntryModeVatIncluded': 'KDV dahil',
  'items.priceVariesByBatch': 'Partiye göre değişir',
  'items.unit': 'Birim',
  'items.company': 'Şirket',
  'items.minPrice': 'Min Fiyat',
  'items.invalidPriceRange': 'Geçerli fiyatlar girin; minimum fiyat maksimum fiyattan büyük olamaz.',
  'items.maxPrice': 'Max Fiyat',
  'items.noItems': 'Ürün bulunamadı',
  'items.noSearchResults': 'Arama sonucu bulunamadı',
  'items.tryDifferentSearch': 'Farklı bir arama terimi deneyin',
  'items.noFound': 'Ürün bulunamadı',
  'items.noYet': 'Henüz ürün yok',
  'items.getStarted': 'İlk ürününüzü ekleyerek başlayın',
  'items.addFirstItem': 'İlk Ürün Ekle',
  'items.bulkUpload': 'Toplu Yükleme',
  'items.saving': 'Kaydediliyor...',
  'items.create': 'Oluştur',
  'items.update': 'Güncelle',
  'items.deleting': 'Siliniyor...',
  'items.created': 'Ürün başarıyla oluşturuldu',
  'items.updated': 'Ürün başarıyla güncellendi',
  'items.deleted': 'Ürün başarıyla silindi',
  'items.deleteWarning': 'Bu işlem geri alınamaz. Bu ürünle ilişkili tüm veriler kalıcı olarak silinecektir.',
  'items.deleteQuestion': 'Bu ürünü silmek istediğinizden emin misiniz? Bu işlem aşağıdakileri de silecektir:',
  'items.deleteConsequences.allTransactions': 'Bu ürünle ilgili tüm işlemler',
  'items.deleteConsequences.allHistory': 'Tüm envanter ve fiyat geçmişi',
  'items.deleteConsequences.allData': 'Tüm ilgili ürün verileri',
  

  
  // Bulk Upload
  'bulkUpload.bulkUploadItems': 'Toplu Ürün Yükle',
  'bulkUpload.selectCompany': 'Şirket Seç',
  'bulkUpload.selectFile': 'CSV Dosyası Seç',
  'bulkUpload.selectCsvFile': 'CSV Dosyası Seç',
  'bulkUpload.downloadTemplate': 'Şablon İndir',
  'bulkUpload.uploadCustomers': 'Müşterileri Yükle',
  'bulkUpload.uploadItems': 'Ürünleri Yükle',
  'bulkUpload.uploadResults': 'Yükleme Sonuçları',
  'bulkUpload.uploadDescription': 'CSV dosyasından birden fazla ürün yükleyin. Dosya "name" ve "price" sütunlarını içermelidir. İsteğe bağlı sütunlar: "vatRate" (%0, %1, %10 veya %20), "categories" (virgülle ayrılmış kategori adları), "itemNumber" ve "barcode".',
  'bulkUpload.uploadingItems': 'Ürünler yükleniyor...',
  'bulkUpload.successfullyCreatedItems': 'Başarıyla Oluşturulan Ürünler',
  'bulkUpload.andMore': 've {{count}} daha fazla',
  'bulkUpload.andMoreErrors': 've {{count}} daha fazla hata',
  'bulkUpload.total': 'Toplam',
  'bulkUpload.success': 'Başarılı',
  'bulkUpload.errors': 'Hatalar',
  'bulkUpload.pleaseSelectCsvFile': 'Lütfen bir CSV dosyası seçin',
  'bulkUpload.pleaseSelectFile': 'Lütfen bir dosya seçin',
  'bulkUpload.pleaseSelectCompany': 'Lütfen bir şirket seçin',
  'bulkUpload.failedToLoadCompanies': 'Şirketler yüklenemedi',
  'bulkUpload.uploadComplete': 'Toplu yükleme başarıyla tamamlandı',
  'bulkUpload.rowError': 'Satır {0} hatası: {1}',
  'bulkUpload.uploadFailed': 'Yükleme başarısız oldu. Lütfen tekrar deneyin.',
  'bulkUpload.firstNameRequired': 'Ad alanı zorunludur',
  'bulkUpload.lastNameRequired': 'Soyad alanı zorunludur',
  'bulkUpload.invalidEmail': 'Geçersiz e-posta formatı',
  'bulkUpload.taxIdTooLong': 'Vergi kimlik numarası 32 karakteri geçemez',
  'bulkUpload.itemNameRequired': 'Ürün adı zorunludur',
  'bulkUpload.priceRequired': 'Fiyat alanı zorunludur',
  'bulkUpload.priceNonNegative': 'Fiyat negatif olamaz',
  'bulkUpload.priceInvalid': 'Fiyat geçerli bir sayı olmalıdır',
  'bulkUpload.codeInvalid': 'Kod geçersiz karakterler içeriyor',
  'bulkUpload.fileEmpty': 'Dosya boş',
  'bulkUpload.fileMustBeCsv': 'Dosya CSV formatında olmalıdır',
  'bulkUpload.processingError': 'CSV dosyası işlenirken hata oluştu',
  'bulkUpload.companyNotFound': 'Şirket bulunamadı',
  'bulkUpload.companyRequired': 'Süper yönetici şirket belirtmelidir',
  'bulkUpload.userCompanyRequired': 'Kullanıcı bir şirketle ilişkilendirilmelidir',
  'bulkUpload.customerHeadersRequired': "CSV 'firstName' ve 'lastName' sütunlarını içermelidir",
  'bulkUpload.itemHeadersRequired': "CSV 'name' ve 'price' sütunlarını içermelidir. İsteğe bağlı: 'itemNumber', 'barcode', 'vatRate' (%0, %1, %10 veya %20), 'categories'",
  'bulkUpload.vatRateInvalid': 'KDV oranı %0, %1, %10 veya %20 olmalıdır',
  'bulkUpload.vatRateNumberInvalid': 'KDV oranı geçerli bir sayı olmalıdır',
  'bulkUpload.customerAlreadyExists': "'{{value}}' adlı müşteri zaten mevcut",
  'bulkUpload.customerEmailAlreadyExists': 'Bu e-posta adresine sahip müşteri zaten mevcut',
  'bulkUpload.customerTaxIdentificationNumberAlreadyExists': 'Bu vergi kimlik numarasına sahip müşteri zaten mevcut',
  'bulkUpload.duplicateNameRequiresIdentifier': 'Bu isimde bir müşteri zaten mevcut; ayırt etmek için telefon, e-posta veya vergi kimlik numarası ekleyin',
  'bulkUpload.customerAlreadyExistsInCompany': 'Bu müşteri bu şirkette zaten mevcut',
  'bulkUpload.customerRowProcessingError': 'Müşteri satırı işlenemedi',
  'bulkUpload.itemAlreadyExists': "'{{value}}' adlı ürün zaten mevcut",
  'bulkUpload.itemNumberAlreadyExists': "'{{value}}' ürün numarası zaten mevcut",
  'bulkUpload.barcodeAlreadyExists': "'{{value}}' barkodu zaten mevcut",
  
  // Dashboard
  'dashboard.welcome': 'Veresiye\'ye Hoş Geldiniz',
  'dashboard.quickActions': 'Hızlı İşlemler',
  'dashboard.recentActivity': 'Son Aktiviteler',
  
  // Quick Actions
  'quickActions.newSale': 'Yeni Satış',
  'quickActions.newSaleDesc': 'Yeni bir satış kaydı oluştur',
  'quickActions.addCustomer': 'Müşteri Ekle',
  'quickActions.addCustomerDesc': 'Yeni müşteri profili oluştur',
  'quickActions.addItem': 'Ürün Ekle',
  'quickActions.addItemDesc': 'Yeni envanter ürünü ekle',
  'quickActions.addDebt': 'Borç Ekle',
  'quickActions.addDebtDesc': 'Yeni müşteri borcu kaydet',
  'quickActions.addPayment': 'Ödeme Ekle',
  'quickActions.addPaymentDesc': 'Müşteri ödemesi kaydet',
  'quickActions.addUser': 'Kullanıcı Ekle',
  'quickActions.addUserDesc': 'Yeni kullanıcı hesabı oluştur',
  'quickActions.enabledActions': 'Etkin Eylemler',
  'quickActions.availableActions': 'Mevcut Eylemler',
  'quickActions.dragToReorder': 'Sıralamak için tutamacı sürükleyin veya yukarı/aşağı ok tuşlarını kullanın',
  'quickActions.searchCustomer': 'Müşteri Ara',
  'quickActions.searchCustomerDesc': 'Mevcut müşterileri bul',
  'quickActions.browseItems': 'Ürünlere Gözat',
  'quickActions.browseItemsDesc': 'Tüm envanter ürünlerini görüntüle',
  'quickActions.scanBarcode': 'Barkod Okut',
  'quickActions.scanBarcodeDesc': 'Barkodla ürün bul',
  'quickActions.noActionsAvailable': 'Hızlı işlem mevcut değil. İşlemlerinizi özelleştirmek için ayarlar simgesine tıklayın.',
  'quickActions.customizeActions': 'Hızlı İşlemleri Özelleştir',
  'quickActions.categories.customer': 'Müşteri',
  'quickActions.categories.item': 'Ürün',
  'quickActions.categories.user': 'Kullanıcı',
  'quickActions.categories.search': 'Arama',
  'quickActions.categories.debt': 'Borç',
  'quickActions.categories.other': 'Diğer',
  
  // Sales
  'sales.pageDescription': 'Müşterinizi seçin, ürünleri ekleyin ve satışı güvenle tamamlayın.',
  'sales.invalidPaymentAmount': 'Geçerli bir ödeme tutarı girin.',
  'sales.partialPaymentRange': 'Kısmi ödeme sıfırdan büyük ve toplam tutardan küçük olmalı.',
  'sales.noSales': 'Henüz satış kaydı yok.',
  'sales.noSearchResults': 'Bu filtrelere uygun satış bulunamadı.',
  'sales.shopping': 'Alışveriş',
  'sales.salesHistory': 'Satış Geçmişi',
  'sales.companyScope': 'Şirket kapsamı',
  'sales.selectCustomer': 'Müşteri Seç',
  'sales.stepCustomer': 'Müşteri',
  'sales.stepItems': 'Ürünler',
  'sales.stepCart': 'Sepet',
  'sales.continueToItems': 'Ürünleri seç',
  'sales.backToCustomer': 'Müşteriye dön',
  'sales.reviewCart': 'Sepete geç',
  'sales.backToItems': 'Ürünlere dön',
  'sales.selectedCustomer': 'Seçilen Müşteri',
  'sales.searchCustomers': 'Müşteri Ara',
  'sales.newCustomer': 'Yeni Müşteri',
  'sales.createCustomer': 'Yeni Müşteri Oluştur',
  'sales.creating': 'Oluşturuluyor...',
  'sales.addItems': 'Sepete Ürün Ekle',
  'sales.searchItems': 'Ürün Ara',
  'sales.category': 'Kategori',
  'sales.allCategories': 'Tüm Kategoriler',
  'sales.price': 'Fiyat',
  'sales.inStock': 'stokta',
  'sales.inStockGroup': 'Stokta olanlar',
  'sales.outOfStockGroup': 'Stokta olmayanlar',
  'sales.outOfStock': 'Stokta yok',
  'sales.stockQuantity': 'Stok',
  'sales.servicePriceRequired': 'Hizmet fiyatını girin.',
  'sales.servicePriceHelp': 'Bu hizmet satışı için fiyat belirleyin.',
  'sales.priceEntryModeHelp': 'Bu fiyatı {mode} girin.',
  'sales.priceEntryModeVatExcluded': 'KDV hariç',
  'sales.priceEntryModeVatIncluded': 'KDV dahil',
  'sales.inventoryNotTracked': 'Stok takibi yok',
  'sales.batchTracked': 'Parti Takipli',
  'sales.add': 'Ekle',
  'sales.addToCart': 'Sepete Ekle',
  'sales.adding': 'Ekleniyor...',
  'sales.select': 'Seç',
  'sales.selected': 'Seçildi',
  'sales.noCustomersFound': 'Müşteri bulunamadı',
  'sales.noCustomersAvailable': 'Müşteri mevcut değil',
  'sales.failedToLoadItems': 'Ürünler yüklenemedi',
  'sales.noItemsFound': 'Ürün bulunamadı',
  'sales.searchItemsPlaceholder': 'Ürün aramak için yazın...',
  'sales.barcodeNotFound': 'Bu barkodla kayıtlı ürün bulunamadı',
  'sales.batchPrice': 'parti fiyatı',
  'sales.shoppingCart': 'Alışveriş Sepeti',
  'sales.yourCartIsEmpty': 'Sepetiniz boş',
  'sales.addItemsToStart': 'Alışverişe başlamak için ürün ekleyin',
  'sales.clearCart': 'Sepeti Temizle',
  'sales.customer': 'Müşteri',
  'sales.batch': 'Parti',
  'sales.unitPrice': 'Birim Fiyat',
  'sales.unitNetPrice': 'Birim Net',
  'sales.netAmount': 'KDV hariç tutar',
  'sales.vatRate': 'KDV oranı',
  'sales.vatAmount': 'KDV tutarı',
  'sales.grossAmount': 'KDV dahil toplam',
  'sales.checkout': 'Ödeme',
  'sales.completeSale': 'Satışı Tamamla',
  'sales.orderSummary': 'Sipariş Özeti',
  'sales.saleSummary': 'Satış Özeti',
  'sales.totalAmount': 'Toplam Tutar',
  'sales.paymentType': 'Ödeme Türü',
  'sales.fullPaid': 'Tam Ödendi',
  'sales.partialPaid': 'Kısmi Ödendi',
  'sales.noPayment': 'Ödeme Yok',
  'sales.paymentAmount': 'Ödeme Tutarı',
  'sales.paymentMethod': 'Ödeme Yöntemi',
  'sales.cash': 'Nakit',
  'sales.card': 'Kart',
  'sales.bankTransfer': 'Banka Havalesi',
  'sales.check': 'Çek',
  'sales.other': 'Diğer',
  'sales.paymentNotes': 'Ödeme Notları',
  'sales.remainingAmountDebt': 'Kalan tutar borç olarak kaydedilecek',
  'sales.fullAmountDebt': 'Tüm tutar borç olarak kaydedilecek',
  'sales.cancel': 'İptal',
  'sales.processing': 'İşleniyor...',
  'sales.quantity': 'Miktar',
  'sales.invalidQuantity': '0’dan büyük bir tam sayı girin',
  'sales.noBatchesAvailable': 'Mevcut parti yok',
  'sales.available': 'Mevcut',
  'sales.expires': 'Son Kullanma',
  'sales.notesOptional': 'Notlar (İsteğe Bağlı)',
  'sales.selectBatch': 'Parti Seç',
  'sales.total': 'Toplam',
  'sales.changeCustomer': 'Müşteri Değiştir',
  'sales.typeToSearchCustomer': 'Müşteri aramak için yazın...',
  'sales.paymentSuccess': 'Ödeme başarıyla tamamlandı!',
  'sales.saleCompletedSuccessfully': 'Satış başarıyla tamamlandı!',
  'sales.pleaseSelectCustomerFirst': 'Lütfen önce bir müşteri seçin',
  'sales.selectCustomerBeforeAdding': 'Sepete ürün eklemeden önce lütfen bir müşteri seçin',
  'sales.failedToAddItem': 'Ürün sepete eklenemedi',
  'sales.failedToUpdateQuantity': 'Ürün miktarı güncellenemedi',
  'sales.failedToRemoveItem': 'Ürün sepetten kaldırılamadı',
  'sales.failedToCreateSession': 'Alışveriş oturumu oluşturulamadı',
  'sales.failedToValidateStock': 'Stok doğrulaması yapılamadı',
  'sales.failedToCompleteSale': 'Satış tamamlanamadı',
  'sales.noActiveSaleToComplete': 'Tamamlanacak aktif satış yok',
  'sales.shoppingSession': 'Alışveriş oturumu',
  'sales.items': 'ürün',
  'sales.created': 'Oluşturuldu',
  'sales.resume': 'Devam Et',
  'sales.salesHistoryWillBeImplemented': 'Satış geçmişi burada uygulanacak',
  'sales.thisItemUsesBatchTracking': 'Bu ürün parti takibi kullanıyor',
  'sales.failedToLoadCustomers': 'Müşteriler yüklenemedi',
  'sales.failedToCreateCustomer': 'Müşteri oluşturulamadı',
  'sales.searchBySaleNumber': 'Satış Numarasına Göre Ara',
  'sales.enterSaleNumber': 'Satış numarası girin...',
  'sales.searchByCustomer': 'Müşteriye Göre Ara',
  'sales.searchCustomerPlaceholder': 'Müşteri ara...',
  'sales.enterCustomerName': 'Müşteri adı girin...',
  'sales.previousPage': 'Önceki sayfa',
  'sales.nextPage': 'Sonraki sayfa',
  'sales.paymentStatus': 'Ödeme Durumu',
  'sales.completed': 'Tamamlandı',
  'sales.cancelled': 'İptal Edildi',
  'sales.paid': 'Ödendi',
  'sales.partiallyPaid': 'Kısmi Ödendi',
  'sales.unpaid': 'Ödenmedi',
  'sales.saleNumber': 'Satış Numarası',
  'sales.itemNumber': 'Ürün Numarası',
  'sales.saleDate': 'Satış Tarihi',
  'sales.paidAmount': 'Ödenen Tutar',
  'sales.remainingAmount': 'Kalan Tutar',
  'sales.saleDetails': 'Satış Detayları',
  'sales.createdBy': 'Oluşturan',
  'sales.notes': 'Notlar',
  'sales.pageSize': 'Sayfa Boyutu',
  'sales.item': 'Ürün',
  'sales.typeAtLeastTwoCharacters': 'En az 2 karakter yazın',
  'sales.typeCustomerName': 'Müşteri adı yazın...',
  'sales.all': 'Tümü',
  
  // Debts
  'debts.title': 'Cari Hesaplar',
  'debts.pageDescription': 'Müşterilerinizle aranızdaki tüm hesap hareketleri tek yerde.',
  'debts.ledgerTitle': 'Hesap hareketleri',
  'debts.ledgerDescription': 'Borç ve ödeme kayıtlarını tarih sırasıyla inceleyin.',
  'debts.totalRecords': 'Toplam kayıt',
  'debts.page': 'Sayfa',
  'debts.filters': 'Filtreler',
  'debts.activeFilters': 'Aktif filtreler:',
  'debts.showResults': 'Sonuçları göster',
  'debts.sort': 'sırala',
  'debts.openCustomerAccount': 'Müşteri hesabını aç',
  'debts.clearSearch': 'Aramayı temizle',
  'debts.searchPlaceholderShort': 'Müşteri, açıklama ara...',
  'debts.previousPage': 'Önceki sayfa',
  'debts.nextPage': 'Sonraki sayfa',
  'debts.rowsPerPage': 'Sayfa başına kayıt',
  'debts.helpSummary': 'Borç veya ödeme eklemek için ilgili düğmeyi kullanın. Müşteri adına tıklayarak hesap geçmişini açın; tarih ve tutar aralığı için Filtreler’i, görünür alanlar için Sütunlar’ı kullanın. Satıştan oluşan hareketler ilgili satış kaydına bağlıdır.',
  'debts.invalidDateRange': 'Başlangıç tarihi bitiş tarihinden sonra olamaz',
  'debts.filter.startDate': 'Başlangıç tarihi',
  'debts.filter.endDate': 'Bitiş tarihi',
  'debts.filter.minAmount': 'En düşük tutar',
  'debts.filter.maxAmount': 'En yüksek tutar',
  'debts.filter.createdBy': 'Oluşturan',
  'debts.filter.companyId': 'Şirket',
  'debts.subtitle': 'Satış, borç, tahsilat ve iptal hareketleri tek hesapta',
  'debts.addDebt': 'Borç ekle',
  'debts.createDebt': 'Yeni Borç Oluştur',
  'debts.form.debtHint': 'Müşterinin hesabına borç kaydedin.',
  'debts.form.paymentHint': 'Müşteriden aldığınız ödemeyi kaydedin.',
  'debts.form.debtAmountHint': 'Bu tutar müşterinin borcuna eklenir.',
  'debts.form.paymentAmountHint': 'Bu tutar müşterinin borcundan düşülür.',
  'debts.form.saveDebt': 'Borcu Kaydet',
  'debts.form.savePayment': 'Ödemeyi Kaydet',
  'debts.editDebt': 'Borç Düzenle',
  'debts.editPayment': 'Ödeme Düzenle',
  'debts.deleteDebt': 'Borç Sil',
  'debts.customer': 'Müşteri',
  'debts.company': 'Şirket',
  'debts.amount': 'Tutar',
  'debts.transactionDate': 'İşlem Tarihi',
  'debts.transactionDateTime': 'İşlem Tarihi ve Saati',
  'debts.movementType': 'Hareket Türü',
  'debts.manualDebt': 'Borç',
  'debts.saleNumber': 'Satış Numarası',
  'debts.year': 'Yıl',
  'debts.month': 'Ay',
  'debts.allYears': 'Tüm Yıllar',
  'debts.allMonths': 'Tüm Aylar',
  'debts.minAmount': 'Min Tutar',
  'debts.maxAmount': 'Max Tutar',
  'debts.invalidAmountRange': 'Minimum tutar maksimum tutardan büyük olamaz',
  'debts.paymentAmount': 'Ödeme Tutarı',
  'debts.description': 'Açıklama',
  'debts.createdBy': 'Oluşturan',
  'debts.addPayment': 'Ödeme Ekle',
  'debts.createPayment': 'Ödeme Kaydet',
  'debts.payment': 'Ödeme',
  'debts.customerRequired': 'Müşteri seçimi zorunludur',
  'debts.amountRequired': 'Tutar zorunludur',
  'debts.amountInvalid': 'Tutar pozitif bir sayı olmalıdır',
  'debts.descriptionPlaceholder': 'Bu borç için isteğe bağlı açıklama...',
  'debts.noDescription': 'Açıklama yok',
  'debts.newCustomerWillBeCreated': 'Yeni müşteri oluşturulacak',
  'debts.searchPlaceholder': 'Müşteri adı, açıklama, tutar veya oluşturan kişiye göre ara...',
  'debts.loadError': 'Borçlar yüklenemedi',
  'debts.createError': 'Borç oluşturulamadı',
  'debts.updateError': 'Borç güncellenemedi',
  'debts.deleteError': 'Borç silinemedi',
  'debts.deleteConfirmation': 'Bu borcu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  'debts.deleteWarning': 'Bu işlem borç kaydını sistemden kalıcı olarak kaldıracaktır.',
  'debts.totalDebt': 'Toplam Borç',
  'debts.totalCredit': 'Toplam Alacak',
  'debts.filter': 'Göster',
  'debts.allRecords': 'Tümü',
  'debts.debtEntries': 'Borçlar',
  'debts.paymentEntries': 'Ödemeler',
  'debts.debtRecord': 'borç kaydı',
  'debts.debtRecords': 'borç kaydı',
  'debts.paymentRecord': 'ödeme kaydı',
  'debts.paymentRecords': 'ödeme kaydı',
  'debts.sale': 'Satış',
  'debts.paymentForSale': 'Satış Ödemesi',
  'debts.manualPayment': 'Ödeme',
  'debts.salePaidSummary': 'Tamamı ödendi',
  'debts.salePartialSummary': 'Kısmi ödendi',
  'debts.saleUnpaidSummary': 'Ödenmedi',
  'debts.remainingAmountShort': 'Kalan',
  'debts.saleCancellation': 'Satış iptali',
  'debts.movement': 'Hesap hareketi',
  'debts.saleMovementReadOnly': 'Satıştan oluşan hareketler düzenlenemez veya silinemez',
  'debts.noDebts': 'Henüz hesap hareketi yok',
  'debts.addFirstDebt': 'İlk borç veya ödeme kaydınızı ekleyerek başlayın',
  'debts.noSearchResults': 'Arama sonucu bulunamadı',
  'debts.tryDifferentSearch': 'Farklı bir arama terimi deneyin',

  'customerDetail.backToCustomers': 'Müşterilere dön',
  'customerDetail.currentBalance': 'GÜNCEL BAKİYE',
  'customerDetail.customerOwes': 'Müşteriden alacağınız',
  'customerDetail.youOwe': 'Müşteriye borcunuz',
  'customerDetail.noBalance': 'Bakiye yok',
  'customerDetail.balanceCaption': 'Bu tutar, kaydedilen borç ve ödemeler arasındaki farkı gösterir.',
  'customerDetail.infoSubtitle': 'İletişim ve müşteri kayıt bilgileri',
  'customerDetail.infoEmpty': 'Ek müşteri bilgisi bulunmuyor.',
  'customerDetail.movements': 'Hesap hareketleri',
  'customerDetail.filterDates': 'Tarihe göre filtrele',
  'customerDetail.shareDebtSummary': 'Borç özetini paylaş',
  'customerDetail.shareDebtSummaryTitle': 'Borç özetini paylaş',
  'customerDetail.shareDebtSummaryHint': 'Göndermeden önce mesajı inceleyebilir ve düzenleyebilirsiniz.',
  'customerDetail.shareMessageLabel': 'Gönderilecek mesaj',
  'customerDetail.whatsappShare': 'WhatsApp ile paylaş',
  'customerDetail.downloadPdf': 'PDF indir',
  'customerDetail.sharePdf': 'PDF olarak paylaş',
  'customerDetail.pdfPreparing': 'PDF hazırlanıyor...',
  'customerDetail.pdfShareFallback': 'Cihaz paylaşımı desteklemediği için PDF indirildi.',
  'customerDetail.shareFailed': 'Paylaşım başlatılamadı. Lütfen tekrar deneyin.',
  'customerDetail.summaryTitle': 'Borç Özeti',
  'customerDetail.summaryCustomer': 'Müşteri',
  'customerDetail.summaryBalance': 'Güncel bakiye',
  'customerDetail.summaryDate': 'Oluşturulma tarihi',
  'customerDetail.summaryPeriod': 'Hareket dönemi',
  'customerDetail.sharePeriod': 'Hareket dönemi',
  'customerDetail.lastMonth': 'Son 1 ay',
  'customerDetail.lastTwoMonths': 'Son 2 ay',
  'customerDetail.lastYear': 'Son 1 yıl',
  'customerDetail.allMovements': 'Tüm hareketler',
  'customerDetail.customRange': 'Özel tarih aralığı',
  'customerDetail.summaryRecentMovements': 'Son hareketler',
  'customerDetail.summaryNoMovements': 'Son hareket bulunmuyor.',
  'customerDetail.summaryDebt': 'Borç',
  'customerDetail.summaryPayment': 'Ödeme',
  'customerDetail.summaryNoDescription': 'Açıklama yok',

  // Expenses
  'expenses.title': 'Gider Defteri',
  'expenses.formHint': 'Giderin ne için yapıldığını ve ödeme durumunu açıkça kaydedin.',
  'expenses.amountHint': 'Tutarı Türk lirası olarak girin.',
  'expenses.paidHint': 'Ödeme tamamlandıysa işaretleyin.',
  'expenses.clearSearch': 'Aramayı temizle',
  'expenses.invalidDateRange': 'Başlangıç tarihi bitiş tarihinden sonra olamaz.',
  'expenses.subtitle': 'Şirket giderlerini, ödemeleri ve alış kayıtlarını takip edin',
  'expenses.addExpense': 'Gider Ekle',
  'expenses.editExpense': 'Gideri Düzenle',
  'expenses.createExpense': 'Yeni Gider Kaydı',
  'expenses.description': 'Açıklama',
  'expenses.descriptionPlaceholder': 'Örn. Toptancıdan alınan ürünler',
  'expenses.category': 'Kategori',
  'expenses.categoryPlaceholder': 'Örn. Mal alımı, kira, fatura',
  'expenses.amount': 'Tutar',
  'expenses.date': 'İşlem Tarihi',
  'expenses.paid': 'Ödendi',
  'expenses.unpaid': 'Ödenmedi',
  'expenses.paymentMethod': 'Ödeme yöntemi',
  'expenses.notes': 'Not',
  'expenses.optional': 'İsteğe bağlı',
  'expenses.status': 'Durum',
  'expenses.searchPlaceholder': 'Açıklama, kategori veya nota göre ara...',
  'expenses.allStatuses': 'Tüm durumlar',
  'expenses.allCategories': 'Tüm kategoriler',
  'expenses.startDate': 'Başlangıç tarihi',
  'expenses.endDate': 'Bitiş tarihi',
  'expenses.cash': 'Nakit',
  'expenses.card': 'Kart',
  'expenses.bankTransfer': 'Banka havalesi',
  'expenses.check': 'Çek',
  'expenses.other': 'Diğer',
  'expenses.noExpenses': 'Henüz gider kaydı yok',
  'expenses.noSearchResults': 'Arama sonucu bulunamadı',
  'expenses.deleteExpense': 'Gideri Sil',
  'expenses.deleteConfirmation': 'Bu gider kaydını silmek istediğinizden emin misiniz?',
  'expenses.createError': 'Gider kaydı oluşturulamadı',
  'expenses.loadError': 'Gider kayıtları yüklenemedi',
  'expenses.updateError': 'Gider kaydı güncellenemedi',
  'expenses.deleteError': 'Gider kaydı silinemedi',
  'expenses.descriptionRequired': 'Açıklama zorunludur',
  'expenses.amountRequired': 'Geçerli bir pozitif tutar girin',
  'expenses.dateRequired': 'İşlem tarihi zorunludur',
  
  // App & Landing
  'app.description': 'Stok, CRM ve Borç Takip Sistemi',
  'app.tagline': 'Müşteri, stok, satış ve açık hesap kayıtları tek yerde',
  'landing.heroTitle': 'Kayıtlarınız düzenli. Bakiyeleriniz net.',
  'landing.eyebrow': 'Elektronik veresiye, net kayıtlar',
  'landing.workflowTitle': 'İşinizin net özeti',
  'landing.workflowDesc': 'Müşteri, stok, satış ve açık hesap verileri — tek yerde, düzenli ve izlenebilir.',
  'landing.previewLabel': 'Temel kayıtlar, tek görünümde',
  'landing.footerNote': 'Kayıtlarınız net, iş akışınız düzenli.',
  'landing.heroSubtitle': 'Müşteri, stok, satış ve açık hesap hareketlerini tek dijital alanda kaydedin. Güncel durumunuzu ve bakiyelerinizi kolayca kontrol edin.',
  'landing.getStarted': 'Başlayın',
  'landing.login': 'Giriş Yap',
  'landing.featuresTitle': 'Her kayıt için net bir adres',
  'landing.featuresSubtitle': 'Müşteriden stok ve satışa, her hareketi düzenli biçimde kaydedin ve kolayca inceleyin.',
  'landing.featureCustomersTitle': 'Müşteri Yönetimi',
  'landing.featureCustomersDesc': 'Müşteri bilgilerini ve işlem geçmişini tek, düzenli kayıtta tutun.',
  'landing.featureInventoryTitle': 'Stok ve Envanter',
  'landing.featureInventoryDesc': 'Ürünleri, stok seviyelerini, parti takibini ve envanter hareketlerini yönetin.',
  'landing.featureSalesTitle': 'Satış ve Ödeme',
  'landing.featureSalesDesc': 'Nakit, kart veya veresiye ile satış yapın — tam veya kısmi ödeme desteklenir.',
  'landing.featureDebtsTitle': 'Borç Takibi',
  'landing.featureDebtsDesc': 'Borç, tahsilat ve bakiye hareketlerini ayrıntılı kayıtlarda izleyin.',
  'landing.featureMultiTenantTitle': 'Çoklu Şirket',
  'landing.featureMultiTenantDesc': 'Şirket kayıtlarını ayrı tutun; erişimi kullanıcı rollerine göre yönetin.',
  'landing.ctaTitle': 'Kayıtlarınızı düzene alın.',
  'landing.ctaSubtitle': 'Müşteri, stok, satış ve açık hesap verilerini tek dijital çalışma alanında kaydedin ve izleyin.',
  'landing.createAccount': 'Hesap Oluştur',
  'landing.alreadyHaveAccount': 'Zaten hesabınız var mı?',
  'landing.learnMore': 'Daha Fazla Bilgi',
  'landing.metricSales': 'Bugünkü satışlar',
  'landing.metricBalance': 'Açık hesap',
  'landing.activityTitle': 'Haftaya genel bakış',
  'landing.footerBrandLine': 'Doğru kayıtlar. Net kararlar.',
  'landing.footerLinks': 'Keşfedin',
  'landing.footerLogin': 'Giriş',
  'landing.footerRegister': 'Kayıt ol',
  'landing.brandPage': 'Marka',
  'landing.contactLabel': 'İletişim',
  'landing.contactEmail': 'merhaba@yazbiveresiye.com',
  'landing.rights': 'Tüm hakları saklıdır.',
  
  // Roles
  'role.SUPER_ADMIN': 'Süper Yönetici',
  'role.COMPANY_ADMIN': 'Şirket Yöneticisi',
  'role.EMPLOYEE': 'Çalışan',
  
  // Themes
  'theme.light': 'Açık',
  'theme.dark': 'Koyu',
  'theme.switchTheme': 'Tema Değiştir',
  
  // Language
  'language.switchLanguage': 'Dil Değiştir',
  
  // Profile
  'profile.preferences': 'Tema & Dil',
  'profile.preferencesHint': 'Size uygun temayı ve dili seçin.',
  'profile.appearance': 'Tema',
  'profile.language': 'Dil',
  'profile.showPassword': 'Şifreyi göster',
  'profile.hidePassword': 'Şifreyi gizle',
  'profile.personalInfo': 'Kişisel Bilgiler',
  'profile.edit': 'Düzenle',
  'profile.editProfile': 'Profili Düzenle',
  'profile.managedByCompanyAdmin': 'Profiliniz şirket yöneticiniz tarafından yönetilir.',
  'profile.openMenu': 'Profil Menüsü',
  'profile.firstName': 'Ad',
  'profile.firstNameRequired': 'Ad zorunludur',
  'profile.lastName': 'Soyad',
  'profile.lastNameRequired': 'Soyad zorunludur',
  'profile.username': 'Kullanıcı Adı',
  'profile.usernameRequired': 'Kullanıcı adı zorunludur',
  'profile.usernameMinLength': 'Kullanıcı adı en az 3 karakter olmalıdır',
  'profile.usernameMaxLength': 'Kullanıcı adı en fazla 50 karakter olmalıdır',
  'profile.email': 'E-posta',
  'profile.role': 'Rol',
  'profile.changePassword': 'Şifre Değiştir (Opsiyonel)',
  'profile.emailRequired': 'E-posta adresi zorunludur',
  'profile.emailInvalid': 'Lütfen geçerli bir e-posta adresi girin',
  'profile.currentPassword': 'Mevcut Şifre',
  'profile.currentPasswordRequiredForPassword': 'Şifre değiştirmek için mevcut şifrenizi girin',
  'profile.newPassword': 'Yeni Şifre',
  'profile.newPasswordRequired': 'Yeni şifre zorunludur',
  'profile.newPasswordMinLength': 'Yeni şifre en az 6 karakter olmalıdır',
  'profile.confirmPassword': 'Yeni Şifre Onayı',
  'profile.passwordsMismatch': 'Şifreler eşleşmiyor',
  'profile.saveChanges': 'Değişiklikleri Kaydet',
  'profile.cancel': 'İptal',
  'profile.companyInfo': 'Şirket Bilgileri & Tercihler',
  'profile.referralCode': 'Referans kodum',
  'profile.referralCodeHint': 'Bu kodu paylaşarak yeni işletmelerin sizi referans göstermesini sağlayabilirsiniz.',
  'profile.createReferralCode': 'Referans kodu oluştur',
  'profile.copyReferralCode': 'Referans kodunu kopyala',
  'profile.copyReferralLink': 'Paylaşım bağlantısını kopyala',
  'profile.referralCodeCreated': 'Referans kodunuz oluşturuldu.',
  'profile.referralCodeCopied': 'Referans kodu kopyalandı.',
  'profile.referralLinkCopied': 'Paylaşım bağlantısı kopyalandı.',
  'profile.referralCodeCopyError': 'Kopyalama başarısız. Metni seçerek kopyalayabilirsiniz.',
  'profile.referralCodeError': 'Referans kodu oluşturulamadı.',
  'profile.referralCodeInactive': 'Referans kodunuz şu anda kullanılamıyor.',
  'profile.pricingSettings': 'Fiyat ve KDV',
  'profile.editPricingSettings': 'Fiyat ve KDV ayarlarını düzenle',
  'profile.pricingSettingsHint': 'Katalog fiyatlarının KDV dahil veya hariç girilmesini ve yeni ürünlerin varsayılan KDV oranını belirler.',
  'profile.priceEntryMode': 'Katalog fiyat girişi',
  'profile.priceEntryModeHint': 'Yeni katalog ve stok fiyatlarının KDV dahil mi, hariç mi girileceğini seçin.',
  'profile.priceEntryModeVatExcluded': 'Fiyatlar KDV hariç',
  'profile.priceEntryModeVatIncluded': 'Fiyatlar KDV dahil',
  'profile.priceEntryModeSaved': 'Fiyat giriş tercihi kaydedildi.',
  'profile.priceEntryModeSaveError': 'Fiyat giriş tercihi kaydedilemedi.',
  'profile.defaultVatRate': 'Yeni ürünler için varsayılan KDV oranı',
  'profile.defaultVatRateHint': 'Yeni ürünler bu oranla başlar. Her ürün için farklı oran seçebilirsiniz.',
  'profile.defaultVatRateInvalid': 'Desteklenen KDV oranlarından birini seçin: %0, %1, %10 veya %20.',
  'profile.pricingSettingsSaved': 'Fiyatlandırma ayarları kaydedildi.',
  'profile.batchTrackingEnabled': 'Parti takibini kullanıyorum',
  'profile.batchTrackingSetting': 'Ürün Parti Takibi',
  'profile.batchTrackingHint': 'Parti numarası ve son kullanma tarihi gibi parti alanlarını şirketiniz için etkinleştirir.',
  'profile.batchTrackingSaved': 'Parti takibi ayarı kaydedildi.',
  'profile.batchTrackingSave': 'Parti ayarını kaydet',
  'profile.batchTrackingSaveError': 'Parti takibi ayarı kaydedilemedi.',
  'profile.batchTrackingDisableError': 'Parti takipli ürünler varken bu ayar kapatılamaz. Önce ürünleri basit stok modeline geçirin.',
  'profile.company': 'Şirket',
  'profile.noCompany': 'Şirket atanmamış',
  'profile.updateSuccess': 'Profil başarıyla güncellendi',
  'profile.emailVerificationSent': 'Yeni adrese doğrulama e-postası gönderildi',
  'profile.emailVerificationPending': 'E-posta doğrulaması bekleniyor',
  'profile.verifyEmail': 'E-postayı doğrula',
  'profile.currentPasswordRequiredForEmail': 'E-posta değiştirmek için mevcut şifre gereklidir',
  'profile.updateError': 'Profil güncellenemedi',
  'profile.loadError': 'Kullanıcı bilgileri yüklenemedi',
  
  // Dashboard
  'dashboard.title': 'Ana Sayfa',
  'dashboard.homeTitle': 'Ana Sayfa',
  'dashboard.homeHint': 'Günlük işlemlerinizi hızlıca başlatın ve işletmenizin bugünkü durumunu görün.',
  'dashboard.homeLoadError': 'Ana sayfa verileri yüklenemedi.',
  'dashboard.dataLimitError': 'Dashboard verileri güvenli görüntüleme sınırını aşıyor. Lütfen seçili dönemi daraltıp tekrar deneyin.',
  'dashboard.monthSummary': 'Bu ayın özeti',
  'dashboard.monthSummaryHint': 'Satış, tahsilat ve güncel alacak durumu',
  'dashboard.recentSales': 'Son satışlar',
  'dashboard.noRecentSales': 'Henüz satış kaydı bulunmuyor.',
  'dashboard.viewAll': 'Tümünü gör',
  'dashboard.openReports': 'Raporlara git',
  'dashboard.reportsTitle': 'Raporlar',
  'dashboard.reportsHint': 'Satış, tahsilat, gider ve stok hareketlerini dönem bazında inceleyin.',
  'dashboard.overviewHint': 'Günlük işleriniz için hızlı bir başlangıç.',
  'dashboard.userFallback': 'Kullanıcı',
  'dashboard.welcomeBack': 'Tekrar hoş geldiniz, {0}!',
  'dashboard.roleLabel': 'Rol:',
  'dashboard.companies': 'Şirketler',
  'dashboard.users': 'Kullanıcı',
  'dashboard.customers': 'Müşteri',
  'dashboard.items': 'Ürün',
  'dashboard.businessOverview': 'İşletme özeti',
  'dashboard.businessOverviewHint': 'Satış, tahsilat ve stok durumunu tek bakışta görün.',
  'dashboard.period': 'Dönem',
  'dashboard.thisMonth': 'Bu ay',
  'dashboard.last30Days': 'Son 30 gün',
  'dashboard.thisYear': 'Bu yıl',
  'dashboard.refresh': 'Yenile',
  'dashboard.superAdminTitle': 'Superadmin genel görünümü',
  'dashboard.superAdminHint': 'Şirketlerin durumunu ve kullanımını tek ekrandan izleyin.',
  'dashboard.totalCompanies': 'Toplam şirket',
  'dashboard.activeUsageCompanies': 'Son 30 günde kullanan',
  'dashboard.activeSubscriptionCompanies': 'Aktif abonelikli',
  'dashboard.newCompanies': 'Bu dönemde yeni',
  'dashboard.expiringCompanies': '7 günde bitecek',
  'dashboard.restrictedCompanies': 'Erişimi kısıtlı',
  'dashboard.companyManagement': 'Şirket yönetimi',
  'dashboard.companyManagementHint': 'Detay, kullanıcı, abonelik ve şirket notlarına erişin.',
  'dashboard.viewCompanies': 'Şirketleri görüntüle',
  'dashboard.attentionTitle': 'İlgilenilmesi gereken şirketler',
  'dashboard.attentionHint': 'Bu listeler şirket yönetimindeki aynı filtre ve sıralama sözleşmesini kullanır.',
  'dashboard.attentionExpiring': 'Yakında bitecek',
  'dashboard.attentionRestricted': 'Erişimi kısıtlı',
  'dashboard.attentionInactive': '30 gündür kullanmıyor',
  'dashboard.attentionNeverUsed': 'Hiç kullanılmadı',
  'dashboard.attentionEmpty': 'Bu listede eşleşen şirket yok.',
  'dashboard.attentionLoadError': 'İlgilenilmesi gereken şirket listeleri yüklenemedi.',
  'dashboard.attentionOpen': 'Detayı aç',
  'dashboard.attentionEndsAt': 'Bitiş',
  'dashboard.attentionLastActivity': 'Son aktivite',
  'dashboard.totalSales': 'Toplam satış',
  'dashboard.totalCollection': 'Toplam tahsilat',
  'dashboard.totalReceivables': 'Güncel alacak',
  'dashboard.salesCount': '{0} satış kaydı',
  'dashboard.periodCollectionHint': 'Seçili dönemde tahsil edilen',
  'dashboard.receivablesHint': '{0} müşteride bakiye · {1} açık satış',
  'dashboard.stockSalesValue': 'Stok satış değeri',
  'dashboard.stockSalesValueHint': 'Mevcut stok miktarı × güncel satış fiyatı. Maliyet veya kâr değildir.',
  'dashboard.salesAndCollection': 'Satış ve tahsilat',
  'dashboard.salesAndCollectionHint': 'Seçili dönemin hareketi',
  'dashboard.sales': 'Satış',
  'dashboard.collection': 'Tahsilat',
  'dashboard.expenses': 'Gider',
  'dashboard.topDebtors': 'En yüksek bakiyeler',
  'dashboard.topSellingItems': 'En çok satan ürünler',
  'dashboard.topDebtorsHint': 'Güncel kalan bakiyeye göre',
  'dashboard.topSellingItemsHint': 'Seçili döneme göre',
  'dashboard.noTopDebtors': 'Açık bakiyesi olan müşteri bulunmuyor.',
  'dashboard.noTopSellingItems': 'Seçili dönemde ürün satışı bulunmuyor.',
  'dashboard.quantity': 'adet',
  'dashboard.attention': 'Dikkat edilmesi gerekenler',
  'dashboard.outOfStockProducts': 'Stokta olmayan ürünler',
  'dashboard.outOfStockProductsDetail': '{0} ürünün stoğu tükendi.',
  'dashboard.unpaidExpenses': 'Ödenmemiş giderler',
  'dashboard.unpaidExpensesDetail': 'Seçili dönemde toplam {0} ödenmemiş gider var.',
  'dashboard.expiringBatches': 'SKT yaklaşan/bitmiş partiler',
  'dashboard.expiringBatchesDetail': '{0} parti için SKT bilgisi bulunuyor.',
  'dashboard.overdueInstallments': 'Geciken taksitler',
  'dashboard.overdueInstallmentsDetail': '{0} müşteride {1} geciken taksit · toplam {2}',
  'dashboard.dueSoonInstallments': 'Yaklaşan taksitler',
  'dashboard.dueSoonInstallmentsDetail': '{0} müşterinin {1} taksiti 5 gün içinde · toplam {2}',
  'dashboard.noAlerts': 'Şu an için dikkat gerektiren bir durum yok.',
  'dashboard.detailLinksTitle': 'Detaylara devam edin',
  'dashboard.batchExpiryHint': 'SKT bilgisi yalnızca parti takipli ürünlerde gösterilir.',
  'dashboard.openReceivables': 'Cari hesaplar',
  'dashboard.openStock': 'Stok görünümü',
  'dashboard.emptyState': 'Henüz gösterilecek satış veya ürün verisi bulunmuyor.',
  
  // Filters
  'filters.title': 'Filtreler',
  'filters.clear': 'Filtreleri Temizle',
  'filters.apply': 'Filtreleri Uygula',
  'filters.createdBy': 'Oluşturan',
  'filters.dateRange': 'Tarih Aralığı',
  'filters.startDate': 'Başlangıç Tarihi',
  'filters.endDate': 'Bitiş Tarihi',
  'filters.amountRange': 'Tutar Aralığı',
  'filters.minAmount': 'Min Tutar',
  'filters.maxAmount': 'Max Tutar',
  'filters.allUsers': 'Tüm Kullanıcılar',
  'filters.company': 'Şirket',
  'filters.allCompanies': 'Tüm Şirketler',
  'filters.showFilters': 'Filtreleri Göster',
  'filters.hideFilters': 'Filtreleri Gizle',
  
  // DataGrid
  'dataGrid.noRowsLabel': 'Satır yok',
  'dataGrid.noResultsOverlayLabel': 'Sonuç bulunamadı.',
  'dataGrid.errorOverlayDefaultLabel': 'Bir hata oluştu.',
  'dataGrid.toolbarDensity': 'Yoğunluk',
  'dataGrid.toolbarDensityLabel': 'Yoğunluk',
  'dataGrid.toolbarDensityCompact': 'Kompakt',
  'dataGrid.toolbarDensityStandard': 'Standart',
  'dataGrid.toolbarDensityComfortable': 'Rahat',
  'dataGrid.toolbarColumns': 'Sütunlar',
  'dataGrid.toolbarColumnsLabel': 'Sütun seç',
  'dataGrid.toolbarFilters': 'Filtreler',
  'dataGrid.toolbarFiltersLabel': 'Filtreleri göster',
  'dataGrid.toolbarFiltersTooltipHide': 'Filtreleri gizle',
  'dataGrid.toolbarFiltersTooltipShow': 'Filtreleri göster',
  'dataGrid.toolbarFiltersTooltipActive': 'filtre aktif',
  'dataGrid.toolbarExport': 'Dışa Aktar',
  'dataGrid.toolbarExportLabel': 'Dışa Aktar',
  'dataGrid.toolbarExportCSV': 'CSV olarak indir',
  'dataGrid.toolbarExportPrint': 'Yazdır',
  'dataGrid.columnMenuLabel': 'Menü',
  'dataGrid.columnMenuShowColumns': 'Sütunları göster',
  'dataGrid.columnMenuFilter': 'Filtrele',
  'dataGrid.columnMenuHideColumn': 'Gizle',
  'dataGrid.columnMenuUnsort': 'Sıralamayı kaldır',
  'dataGrid.columnMenuSortAsc': 'Artan sırala',
  'dataGrid.columnMenuSortDesc': 'Azalan sırala',
  'dataGrid.columnHeaderFiltersTooltipActive': 'filtre aktif',
  'dataGrid.columnHeaderFiltersLabel': 'Filtreleri göster',
  'dataGrid.columnHeaderSortIconLabel': 'Sırala',
  'dataGrid.footerRowSelected': 'satır seçildi',
  'dataGrid.footerTotalRows': 'Toplam Satır:',
  'dataGrid.footerTotalVisibleRows': 'görünen satır:',
  'dataGrid.checkboxSelectionHeaderName': 'Checkbox seçimi',
  'dataGrid.booleanCellTrueLabel': 'evet',
  'dataGrid.booleanCellFalseLabel': 'hayır',
  'dataGrid.actionsCellMore': 'daha fazla',
  'dataGrid.filterPanelAddFilter': 'Filtre ekle',
  'dataGrid.filterPanelDeleteIconLabel': 'Sil',
  'dataGrid.filterPanelLinkOperator': 'Mantık operatörü',
  'dataGrid.filterPanelOperators': 'Operatörler',
  'dataGrid.filterPanelOperatorAnd': 'Ve',
  'dataGrid.filterPanelOperatorOr': 'Veya',
  'dataGrid.filterPanelColumns': 'Sütunlar',
  'dataGrid.filterPanelInputLabel': 'Değer',
  'dataGrid.filterPanelInputPlaceholder': 'Filtre değeri',
  'dataGrid.filterOperatorContains': 'içerir',
  'dataGrid.filterOperatorEquals': 'eşittir',
  'dataGrid.filterOperatorStartsWith': 'ile başlar',
  'dataGrid.filterOperatorEndsWith': 'ile biter',
  'dataGrid.filterOperatorIs': 'dir',
  'dataGrid.filterOperatorNot': 'değildir',
  'dataGrid.filterOperatorAfter': 'sonrasında',
  'dataGrid.filterOperatorOnOrAfter': 'veya sonrasında',
  'dataGrid.filterOperatorBefore': 'öncesinde',
  'dataGrid.filterOperatorOnOrBefore': 'veya öncesinde',
  'dataGrid.filterOperatorIsEmpty': 'boş',
  'dataGrid.filterOperatorIsNotEmpty': 'boş değil',
  'dataGrid.filterOperatorIsAnyOf': 'herhangi biri',

  // Categories
  'category.title': 'Kategoriler',
  'category.created': 'Kategori oluşturuldu.',
  'category.updated': 'Kategori güncellendi.',
  'category.deleted': 'Kategori silindi.',
  'category.managementHint': 'Ürünlerinizi gruplamak için kategorileri düzenleyin.',
  'category.actions': 'Kategori işlemleri',
  'category.add': 'Kategori Ekle',
  'category.edit': 'Kategori Düzenle',
  'category.create': 'Kategori Oluştur',
  'category.delete': 'Kategori Sil',
  'category.manage': 'Kategorileri Yönet',
  'category.name': 'Kategori Adı',
  'category.description': 'Açıklama',
  'category.color': 'Renk',
  'category.noDescription': 'Açıklama yok',
  'category.noCategories': 'Kategori bulunamadı. Başlamak için ilk kategorinizi oluşturun.',
  'category.nameRequired': 'Kategori adı gereklidir',
  'category.colorInvalid': 'Renk geçerli bir hex renk kodu olmalıdır',
  'category.failedToSave': 'Kategori kaydedilemedi. Lütfen tekrar deneyin.',
  'category.deleteConfirmation': '"{name}" kategorisini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
  'category.addNewCategory': 'Yeni Kategori Ekle',

  // Items
  'items.pricePerUnitRequired': 'Birim fiyat (gerekli)',
  'items.salePricePerUnitRequired': 'Birim satış fiyatı (gerekli)',

  // Categories (for item form)
  'categories.categories': 'Kategoriler',
  'categories.selectCategories': 'Kategorileri seçin',
  'categories.filterByCategory': 'Kategoriye göre filtrele',
  'categories.manageCategories': 'Kategorileri Yönet',

  // Column Configuration
  'columns.title': 'Sütunlar',
  'columns.configuration': 'Sütun Yapılandırması',
  'columns.manage': 'Sütunları Yönet',
  'columns.show': 'Sütunları Göster',
  'columns.hide': 'Sütunları Gizle',

  // Filter
  'filter.categories': 'Filtredeki kategoriler',
  'filter.selectCategories': 'Filtrelemek için kategorileri seçin',

  // Loading
  'loading.failedToLoad': 'Yüklenemedi',
  
  // Help System (Turkish)
  'help.dontShowAgain': 'Bir daha gösterme',
  'help.searchPlaceholder': 'Yardım konularında ara',
  'help.topicCount': 'konu',
  'help.noResults': 'Bu aramayla eşleşen yardım konusu bulunamadı.',
  'faq.searchPlaceholder': 'Sorularda ara',
  'faq.noResults': 'Bu aramayla eşleşen soru bulunamadı.',
  'faq.allTopics': 'Tüm konular',
  'faq.browseTopics': 'Konuya göre göz atın',
  'help.gotIt': 'Anladım',
  'help.toggleHelp': 'Yardımı Aç/Kapat',
  'help.resetHelp': 'Sıfırla',
  'help.helpSettings': 'Yardım Ayarları',
  'help.pageHelp': 'Sayfa Yardımı',
  'help.contextualHelpDescription': 'Uygulama boyunca bağlamsal yardım ipuçlarını göster',
  'help.availableTopics': 'Mevcut Yardım Konuları',
  'help.topicsDescription': 'Bu yardım ipuçları ilgili özelliklerin yanında görünür ve uygulamada size rehberlik eder.',
  'help.disableInfo': 'Her ipucunda "Bir daha gösterme" seçeneğini tıklayarak bireysel yardım ipuçlarını devre dışı bırakabilir veya aşağıdaki butonu kullanarak tüm yardımları sıfırlayabilirsiniz.',
  'help.resetDescription': 'Daha önce devre dışı bırakılan tüm yardım ipuçlarını yeniden etkinleştir',
  'help.inventoryManagementDesc': 'Ürün envanteri ve stok seviyelerini nasıl yöneteceğiniz',
  'help.batchTrackingDesc': 'Gelişmiş envanter için parti takibini anlama',
  'help.addCustomerDesc': 'Sisteme yeni müşteri ekleme yöntemi',
  'help.addItemDesc': 'Yeni ürün ve malzeme ekleme yöntemi',
  'help.userManagementDesc': 'Kullanıcıları ve rollerini yönetme',
  'help.debtManagementDesc': 'Müşteri borçları ve ödemelerini yönetme',
  
  // Page-specific help content (Turkish)
  'help.items.title': 'Ürünler Sayfası Yardımı',
  'help.items.content': 'Ürün ve hizmetlerinizi burada arayın, filtreleyin ve yönetin. Ürünlerde stok takibi yapılır; hizmetlerde stok tutulmaz. Toplu yüklenen ürünlerin stoğu sıfır başlar.',
  'help.customers.title': 'Müşteriler Sayfası Yardımı',
  'help.customers.content': 'Müşterileri ad veya soyada göre arayın, müşteri detayını ve hesap geçmişini açın. Ad ve soyad zorunludur; satış veya borç kaydı olan müşteri silinemez.',
  'help.users.title': 'Kullanıcılar Sayfası Yardımı',
  'help.users.content': 'Çalışan hesaplarını oluşturun ve yönetin. Şirket Yöneticileri yalnızca yetkileri içindeki kullanıcıları düzenleyebilir veya silebilir.',
  'help.debts.title': 'Cari Hesaplar Yardımı',
  'help.debts.content': 'Cari Hesaplar’da borç ve ödeme hareketi ekleyin. Müşteri adına tıklayarak geçmişi açın; ödeme müşterinin bakiyesini azaltır.',
  'help.sales.title': 'Satışlar Sayfası Yardımı',
  'help.sales.content': 'Bir müşteri seçin, ürünleri sepete ekleyin ve tam, kısmi veya ödemesiz satış kaydını tamamlayın. Tamamlanan satışları ve ödeme durumlarını Satış Geçmişi sekmesinden inceleyin.',
  'help.expenses.title': 'Gider Defteri Sayfası Yardımı',
  'help.expenses.content': 'Şirket gideri ve alış kayıtlarını kategori, ödeme durumu ve yöntemiyle kaydedin. Kayıtları arayın veya kategori, durum ve tarih aralığına göre filtreleyin.',

  // Inventory Management (Turkish)
  'inventory.title': 'Envanter',
  'inventory.invalidQuantity': 'Sıfır veya daha büyük bir tam sayı girin.',
  'inventory.expirationAfterProduction': 'Son kullanma tarihi üretim tarihinden önce olamaz.',
  'inventory.stockOverview': 'Stok özeti',
  'inventory.stockOverviewHint': 'Stok hareketlerini ve partileri buradan takip edin.',
  'inventory.batchSettings': 'Parti ayarları',
  'inventory.selectBatchToAdjust': 'Düzenlemek için bir parti seçin',
  'inventory.noStockToRemove': 'Çıkarılacak stok yok',
  'inventory.operationPreview': 'İşlem sonrası stok',
  'inventory.management': 'Envanter Yönetimi',
  'inventory.manageInventory': 'Envanteri Yönet',
  'inventory.currentStock': 'Mevcut Stok',
  'inventory.currentPrice': 'Mevcut Fiyat',
  'inventory.editingBatch': 'Parti Düzenleniyor',
  'inventory.stock': 'Stok',
  'inventory.units': 'adet',
  'inventory.addStock': 'Stok Ekle',
  'inventory.removeStock': 'Stok Çıkar',
  'inventory.adjustStock': 'Stok Ayarla',
  'inventory.adjustStockError': 'Stok ayarlama başarısız oldu',
  'inventory.deleteBatch': 'Partiyi Sil',
  'inventory.deleteBatchError': 'Parti silme başarısız oldu',
  'inventory.deleteBatchConfirm': 'Parti Silinsin mi?',
  'inventory.deleteBatchWarning': 'Bu işlem geri alınamaz.',
  'inventory.deleteBatchMessage': 'Bu partiyi silmek istediğinizden emin misiniz? Parti silinebilmesi için kalan stok 0 olmalıdır.',
  'inventory.cannotDeleteBatchWithStock': 'Kalan stoğu olan parti silinemez. Lütfen önce stoğu 0\'a ayarlayın.',
  'inventory.enterBatchNumber': 'Parti numarası girin',
  'inventory.batchNumberHelpText': 'Gerekirse parti numarasını güncelleyin',
  'inventory.quickActions': 'Hızlı İşlemler',
  'inventory.doubleClickBatchToEdit': 'Bir partinin detaylarını düzenlemek için listedeki partiye çift tıklayın',
  'inventory.batches': 'Partiler',
  'inventory.transactions': 'İşlemler',
  'inventory.batchTracking': 'Parti Takibi',
  'inventory.enableBatchTracking': 'Parti Takibini Etkinleştir',
  'inventory.batchTrackingHelp': 'Üretim ve son kullanma tarihleriyle bireysel partileri takip edin',
  'inventory.simpleInventoryHelp': 'Stok miktarını tek bir toplam olarak takip edin.',
  'inventory.batchTracked': 'Parti Takipli',
  'inventory.activeBatches': 'aktif parti',
  'inventory.price': 'Fiyat',
  'inventory.salePrice': 'Satış fiyatı',
  'inventory.priceEntryModeHelp': 'Fiyatı {mode} girin.',
  'inventory.priceEntryModeVatExcluded': 'KDV hariç',
  'inventory.priceEntryModeVatIncluded': 'KDV dahil',
  'inventory.quantity': 'Miktar',
  'inventory.batchNumber': 'Parti Numarası',
  'inventory.batchNumberPlaceholder': 'Başlangıç stoğunun parti numarasını girin',
  'inventory.batchSelection': 'Parti',
  'inventory.newBatch': 'Yeni parti oluştur',
  'inventory.selectExistingBatch': 'Mevcut partiye ekle',
  'inventory.batchStockOption': '{batchNumber} ({quantity} adet)',
  'inventory.existingBatchPriceHelp': 'Mevcut partinin satış fiyatı korunur.',
  'inventory.batchSalePrice': 'Parti satış fiyatı',
  'inventory.newBatchPriceHelp': 'Bu yeni parti için satış fiyatını belirleyin. Varsayılan olarak ürün fiyatı kullanılır.',
  'inventory.batchPriceEditHelp': 'Bu değişiklik yalnızca bu partiyi etkiler. Önceki satışların fiyatı değişmez.',
  'inventory.productionDate': 'Üretim Tarihi',
  'inventory.expirationDate': 'Son Kullanma Tarihi',
  'inventory.notes': 'Notlar',
  'inventory.notesPlaceholder': 'Bu stok işlemi hakkında notlar ekleyin...',
  'inventory.advancedOptions': 'Gelişmiş Seçenekler',
  'inventory.summary': 'Özet',
  'inventory.newTotal': 'Yeni Toplam',
  'inventory.quantityToRemove': 'Çıkarılacak Miktar',
  'inventory.available': 'Mevcut',
  'inventory.reasonForRemoval': 'Çıkarma nedeni (isteğe bağlı)',
  'inventory.outOfStock': 'Stokta Yok',
  'inventory.newQuantity': 'Yeni Miktar',
  'inventory.currentQuantity': 'Mevcut Miktar',
  'inventory.reasonForAdjustment': 'Ayarlama nedeni (isteğe bağlı)',
  'inventory.change': 'Değişiklik',
  'inventory.increase': 'Artış',
  'inventory.decrease': 'Azalış',
  'inventory.initialStock': 'Başlangıç Stoku',
  'inventory.initialStockHelp': 'Bu ürün için başlangıç miktarı',
  'inventory.batchDetails': 'Parti Detayları',
  'inventory.noBatches': 'Bu ürün için parti bulunamadı',
  'inventory.noBatchNumber': 'Parti numarası yok',
  'inventory.remaining': 'Kalan',
  'inventory.status': 'Durum',
  'inventory.active': 'Aktif',
  'inventory.expired': 'Süresi Dolmuş',
  'inventory.expiringSoon': 'Süresi Yakında Dolacak',
  'inventory.empty': 'Boş',
  'inventory.batchSummary': 'Parti Özeti',
  'inventory.totalBatches': 'Toplam Parti',
  'inventory.expiredBatches': 'Süresi Dolmuş Partiler',
  'inventory.expiringSoonBatches': 'Süresi Yakında Dolacak Partiler',
  'inventory.batchTotal': 'Parti Toplamı',
  'inventory.financialSummary': 'Mali Özet',
  'inventory.totalQuantity': 'Toplam Miktar',
  'inventory.totalValue': 'Toplam Değer',
  'inventory.transactionHistory': 'İşlem Geçmişi',
  'inventory.noTransactions': 'Bu ürün için işlem bulunamadı',
  'inventory.type': 'Tür',
  'inventory.before': 'Önce',
  'inventory.after': 'Sonra',
  'inventory.user': 'Kullanıcı',
  'inventory.date': 'Tarih',
  'inventory.transactionType.add': 'Ekle',
  'inventory.transactionType.remove': 'Çıkar',
  'inventory.transactionType.adjust': 'Ayarla',
  'inventory.transactionType.sale': 'Satış',
  'inventory.transactionType.modeChange': 'Mod değişikliği',
  'inventory.transactionNotes.batchToSimple': 'Parti takibi kapatıldı ve stok basit stok modelinde birleştirildi.',
  'inventory.transactionNotes.stockConsolidated': 'Stok basit stok modelinde birleştirildi.',
  'inventory.transactionNotes.legacyRowConsolidated': 'Eski basit stok satırı parti geçişi sırasında birleştirildi.',
  'inventory.transactionNotes.legacySimpleToBatch': 'Eski basit stok modeli parti takibine dönüştürüldü.',
  'inventory.transactionNotes.simpleToBatch': 'Basit stok modeli parti takibine dönüştürüldü.',
  'inventory.transactionSummary': 'İşlem Özeti',
  'inventory.totalTransactions': 'Toplam İşlem',
  'inventory.additions': 'Eklemeler',
  'inventory.removals': 'Çıkarmalar',
  'inventory.adjustments': 'Ayarlamalar',
  'inventory.selectBatch': 'Parti Seç',
  'inventory.autoSelectFIFO': 'Otomatik seç (FIFO)',
  'inventory.inBatch': 'partide',
  'inventory.selectedBatch': 'Seçilen Parti',
  'inventory.batchInfo': 'Parti Bilgisi',
  'inventory.adjustStockBatchInfo': 'Not: Parti takipli ürünler için toplam stok ayarlama, fazla stoku çıkarmak veya en eski partiye eklemek için FIFO mantığını kullanır.',
  'inventory.addingSummary': 'Ekleniyor',
  'inventory.removingSummary': 'Çıkarılıyor',
  'inventory.total': 'Toplam',
  'inventory.batchTrackingToggleError': 'Parti takibi değiştirilemedi',
  'inventory.cannotDisableBatchTrackingMultiple': 'Tüm partilerdeki mevcut stok basit stokta birleştirilecek.',
  'inventory.cannotDisableBatchTrackingStock': 'Mevcut parti stokları basit stokta birleştirilecek.',
  'inventory.cannotDisableBatchTrackingBackend': 'Geçiş sırasında satış geçmişi ve işlem kayıtları korunur.',
  'inventory.batchNumberRequired': 'Parti takibi açıkken parti numarası zorunludur.',
  'inventory.batchNumberRequiredForExistingStock': 'Mevcut stok için takibi açmadan önce parti numarası girin.',
  'inventory.batchNumberOptionalForExistingStock': 'İsteğe bağlıdır. Boş bırakırsanız sistem geçiş partisini otomatik oluşturur.',
  'inventory.batchNumberAlreadyExists': 'Bu parti numarası bu ürün için zaten kullanılıyor.',
  'inventory.itemNotFound': 'Ürün bulunamadı.',
  'inventory.inventoryNotTracked': 'Bu ürün için envanter takibi kullanılmıyor.',
  'inventory.inventoryModeUnchanged': 'Bu envanter modu zaten seçili.',
  'inventory.inventoryTransitionNotAllowed': 'Bu ürün için envanter modu değiştirilemez.',
  'inventory.inventoryTransitionFailed': 'Envanter modu değiştirilemedi. Lütfen tekrar deneyin.',
  'inventory.enableBatchTrackingConfirmTitle': 'Parti takibi açılsın mı?',
  'inventory.enableBatchTrackingConfirmMessage': 'Mevcut stok tek bir partiye aktarılacak. İsterseniz parti numarası belirtebilirsiniz.',
  'inventory.disableBatchTrackingConfirmTitle': 'Basit stok modeline geçilsin mi?',
  'inventory.disableBatchTrackingConfirmMessage': 'Tüm partilerdeki mevcut stok basit stokta birleştirilecek. Satış geçmişi ve işlem kayıtları değişmeden korunacak.',


  // Bulk Upload Customers
  'bulkUploadCustomers.bulkUploadCustomers': 'Toplu Müşteri Yükleme',
  'bulkUploadCustomers.uploadDescription': 'CSV dosyasından birden fazla müşteri yükleyin. Zorunlu sütunlar: "firstName" ve "lastName". İsteğe bağlı sütunlar: "email", "phone", "address", "taxIdentificationNumber".',
  'bulkUploadCustomers.uploadingCustomers': 'Müşteriler yükleniyor...',
  'bulkUploadCustomers.successfullyCreatedCustomers': 'Başarıyla Oluşturulan Müşteriler',

  // Brand page
  'brand.pageTitle': 'Marka kimliği',
  'brand.eyebrow': 'VERESİYE MARKA KİMLİĞİ',
  'brand.headline': 'Doğru kayıtlar. Net kararlar.',
  'brand.description': 'Veresiye, müşteri, stok, satış ve açık hesap hareketlerini elektronik ortamda düzenli ve izlenebilir kayıtlar halinde toplar.',
  'brand.electronicBadge': 'ELEKTRONİK VERESİYE',
  'brand.lockupDescription': 'Altın e, elektronik kayıt odağını vurgular. Sade çizgiler, düzenli ve okunabilir kayıt tutma yaklaşımını yansıtır.',
  'brand.symbolTitle': 'Esnaf',
  'brand.symbolDescription': 'Esnaf simgesi, günlük işlemlerin merkezindeki kullanıcıyı temsil eder. Açık form ve V kıvrımı, kayıtların net ve düzenli tutulmasını anlatır.',
  'brand.paletteTitle': 'Marka renkleri',
  'brand.pine': 'Çam yeşili',
  'brand.brass': 'Vurgu altını',
  'brand.paper': 'Yumuşak krem',
};
